import { shallowMount } from "@vue/test-utils";
import Gracias from "@/views/Gracias";

describe("Gracias component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Gracias);
  });

  it("Renders del view Gracias", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
